export * from "/__w/wiggot-web/wiggot-web/packages/web-components/utils/validateAdSelectedOptions.ts"